import React from 'react';
import { Link } from 'react-router-dom';
import doctorImage from '../img/image35.png';

const MeetTheDoctor = () => {
  const [isPrimaryHovered, setIsPrimaryHovered] = React.useState(false);

  return (
    <section style={styles.section} className="meet-doctor-section">
      <div style={styles.container} className="meet-doctor-container">
        {/* Image Column - Left Side */}
        <div style={styles.imageColumn} className="meet-doctor-image-column">
          <div style={styles.imageContainer} className="meet-doctor-image-container">
            <img 
              src={doctorImage} 
              alt="Dietitian Karpagam"
              style={styles.image}
              className="meet-doctor-image"
            />
          </div>
        </div>

        {/* Content Column - Right Side */}
        <div style={styles.contentColumn} className="meet-doctor-content-column">
          <h2 style={styles.title} className="meet-doctor-title">
            Dietitian Karpagam
          </h2>
          
          <p style={styles.subtitle} className="meet-doctor-subtitle">
            I'm Dietitian Karpagam, a practical and service-oriented nutrition professional with over 6 years of experience in clinical and lifestyle nutrition. After completing my M.Sc. in Clinical Nutrition and working at Apollo Hospitals, Chennai, I've helped hundreds of individuals transform their health through science-based, realistic diet plans.
            If you're ready to eat better, feel better, and live better
          </p>

          {/* Qualifications List */}
          <div style={styles.qualifications} className="meet-doctor-qualifications">
            <div style={styles.qualificationItem} className="meet-doctor-qualification-item">
              <div style={styles.qualificationText} className="meet-doctor-qualification-text">
                <strong>"Wellness doesn't begin in the lab or gym — it begins on your plate."</strong>
              </div>
            </div>
          </div>

          {/* Horizontal Divider */}
          <div style={styles.divider} className="meet-doctor-divider"></div>

          {/* Buttons */}
          <div style={styles.buttonContainer} className="meet-doctor-button-container">
            <Link 
              to="/about"
              style={{
                ...styles.primaryButton,
                ...(isPrimaryHovered ? styles.primaryButtonHover : {})
              }}
              className="meet-doctor-primary-button"
              onMouseEnter={() => setIsPrimaryHovered(true)}
              onMouseLeave={() => setIsPrimaryHovered(false)}
            >
              Know More About Me →
            </Link>
          </div>
        </div>
      </div>

      {/* Responsive CSS for all devices */}
      <style>
        {`
          /* Base styles */
          .meet-doctor-section {
            padding: 80px 24px !important;
            background-color: #ffffff !important;
          }
          
          .meet-doctor-container {
            max-width: 1200px !important;
            margin: 0 auto !important;
            display: flex !important;
            align-items: flex-start !important;
            gap: 80px !important;
          }
          
          /* Default image container - Desktop */
          .meet-doctor-image-container {
            width: 260px !important;
            height: 400px !important;
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
          }
          
          .meet-doctor-image {
            width: 100% !important;
            height: 100% !important;
            object-fit: cover !important;
            object-position: center !important;
          }
          
          /* Desktop - Large screens (1440px+) */
          @media (min-width: 1440px) {
            .meet-doctor-container {
              gap: 100px !important;
            }
            .meet-doctor-image-container {
              width: 300px !important;
              height: 460px !important;
            }
            .meet-doctor-title {
              font-size: 3rem !important;
            }
            .meet-doctor-subtitle {
              font-size: 1.25rem !important;
            }
          }
          
          /* Desktop - Medium screens (1200px-1439px) */
          @media (min-width: 1200px) and (max-width: 1439px) {
            .meet-doctor-image-container {
              width: 280px !important;
              height: 430px !important;
            }
          }
          
          /* Desktop - Standard (1025px-1199px) */
          @media (min-width: 1025px) and (max-width: 1199px) {
            .meet-doctor-container {
              gap: 60px !important;
            }
            .meet-doctor-image-container {
              width: 260px !important;
              height: 400px !important;
            }
            .meet-doctor-title {
              font-size: 2.5rem !important;
            }
          }
          
          /* Nest Hub Max (1280px) */
          @media (max-width: 1280px) and (min-width: 1025px) {
            .meet-doctor-container {
              gap: 60px !important;
            }
            .meet-doctor-title {
              font-size: 2.5rem !important;
            }
          }
          
          /* iPad Pro, Surface Pro 7, Nest Hub (769px-1024px) */
          @media (max-width: 1024px) and (min-width: 769px) {
            .meet-doctor-container {
              gap: 50px !important;
              align-items: center !important;
            }
            .meet-doctor-image-container {
              width: 240px !important;
              height: 370px !important;
            }
            .meet-doctor-title {
              font-size: 2.4rem !important;
            }
            .meet-doctor-subtitle {
              font-size: 1.1rem !important;
              max-width: 100% !important;
            }
            .meet-doctor-primary-button {
              padding: 14px 32px !important;
              font-size: 1rem !important;
            }
          }
          
          /* iPad Mini, iPad Air (540px-820px) - Tablet Portrait */
          @media (max-width: 820px) and (min-width: 540px) {
            .meet-doctor-container {
              flex-direction: column !important;
              gap: 40px !important;
              text-align: center !important;
              align-items: center !important;
            }
            .meet-doctor-image-column {
              width: 100% !important;
              display: flex !important;
              justify-content: center !important;
            }
            .meet-doctor-image-container {
              width: 260px !important;
              height: 400px !important;
              margin: 0 auto !important;
            }
            .meet-doctor-title {
              font-size: 2.2rem !important;
              text-align: center !important;
            }
            .meet-doctor-subtitle {
              font-size: 1.05rem !important;
              text-align: center !important;
              max-width: 100% !important;
              margin-bottom: 25px !important;
            }
            .meet-doctor-content-column {
              padding-top: 0 !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              width: 100% !important;
            }
            .meet-doctor-qualification-text {
              text-align: center !important;
            }
            .meet-doctor-button-container {
              justify-content: center !important;
            }
            .meet-doctor-primary-button {
              padding: 14px 30px !important;
            }
          }
          
          /* Surface Duo (540px-720px) */
          @media (max-width: 720px) and (min-width: 540px) {
            .meet-doctor-section {
              padding: 60px 20px !important;
            }
            .meet-doctor-image-container {
              width: 240px !important;
              height: 370px !important;
            }
            .meet-doctor-title {
              font-size: 2rem !important;
            }
            .meet-doctor-subtitle {
              font-size: 1rem !important;
            }
          }
          
          /* iPhone 14 Pro Max, Pixel 7 (430px-480px) */
          @media (max-width: 480px) and (min-width: 430px) {
            .meet-doctor-section {
              padding: 50px 16px !important;
            }
            .meet-doctor-container {
              flex-direction: column !important;
              gap: 35px !important;
              text-align: center !important;
              align-items: center !important;
            }
            .meet-doctor-image-column {
              width: 100% !important;
              display: flex !important;
              justify-content: center !important;
            }
            .meet-doctor-image-container {
              width: 260px !important;
              height: 400px !important;
              margin: 0 auto !important;
            }
            .meet-doctor-title {
              font-size: 1.9rem !important;
              text-align: center !important;
              margin-bottom: 20px !important;
            }
            .meet-doctor-subtitle {
              font-size: 0.98rem !important;
              text-align: center !important;
              line-height: 1.6 !important;
              margin-bottom: 20px !important;
            }
            .meet-doctor-content-column {
              width: 100% !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }
            .meet-doctor-qualification-text {
              font-size: 0.95rem !important;
              text-align: center !important;
            }
            .meet-doctor-primary-button {
              padding: 13px 28px !important;
              font-size: 0.98rem !important;
            }
          }
          
          /* iPhone 12 Pro, iPhone XR, Samsung Galaxy S20 Ultra (390px-430px) */
          @media (max-width: 430px) and (min-width: 390px) {
            .meet-doctor-section {
              padding: 45px 14px !important;
            }
            .meet-doctor-container {
              flex-direction: column !important;
              gap: 30px !important;
              align-items: center !important;
            }
            .meet-doctor-image-column {
              width: 100% !important;
              display: flex !important;
              justify-content: center !important;
            }
            .meet-doctor-image-container {
              width: 260px !important;
              height: 400px !important;
              margin: 0 auto !important;
            }
            .meet-doctor-title {
              font-size: 1.8rem !important;
              text-align: center !important;
              margin-bottom: 18px !important;
            }
            .meet-doctor-subtitle {
              font-size: 0.95rem !important;
              text-align: center !important;
              line-height: 1.6 !important;
              margin-bottom: 18px !important;
            }
            .meet-doctor-content-column {
              width: 100% !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }
            .meet-doctor-qualification-text {
              font-size: 0.92rem !important;
              text-align: center !important;
            }
            .meet-doctor-primary-button {
              padding: 12px 26px !important;
              font-size: 0.95rem !important;
            }
          }
          
          /* iPhone SE, Samsung Galaxy A51/71 (375px-390px) */
          @media (max-width: 390px) and (min-width: 375px) {
            .meet-doctor-section {
              padding: 40px 12px !important;
            }
            .meet-doctor-container {
              flex-direction: column !important;
              gap: 25px !important;
              align-items: center !important;
            }
            .meet-doctor-image-column {
              width: 100% !important;
              display: flex !important;
              justify-content: center !important;
            }
            .meet-doctor-image-container {
              width: 240px !important;
              height: 370px !important;
              margin: 0 auto !important;
            }
            .meet-doctor-title {
              font-size: 1.7rem !important;
              text-align: center !important;
              margin-bottom: 16px !important;
            }
            .meet-doctor-subtitle {
              font-size: 0.92rem !important;
              text-align: center !important;
              line-height: 1.6 !important;
              margin-bottom: 16px !important;
            }
            .meet-doctor-content-column {
              width: 100% !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }
            .meet-doctor-qualification-text {
              font-size: 0.9rem !important;
              text-align: center !important;
            }
            .meet-doctor-primary-button {
              padding: 11px 24px !important;
              font-size: 0.92rem !important;
            }
            .meet-doctor-divider {
              margin: 30px 0 !important;
            }
          }
          
          /* Samsung Galaxy S8+, Pixel 7 (412px-420px) */
          @media (max-width: 420px) and (min-width: 412px) {
            .meet-doctor-image-column {
              width: 100% !important;
              display: flex !important;
              justify-content: center !important;
            }
            .meet-doctor-image-container {
              width: 260px !important;
              height: 400px !important;
            }
          }
          
          /* Very Small Devices (below 375px) */
          @media (max-width: 374px) {
            .meet-doctor-section {
              padding: 35px 10px !important;
            }
            .meet-doctor-container {
              flex-direction: column !important;
              gap: 20px !important;
              align-items: center !important;
            }
            .meet-doctor-image-column {
              width: 100% !important;
              display: flex !important;
              justify-content: center !important;
            }
            .meet-doctor-image-container {
              width: 220px !important;
              height: 340px !important;
              margin: 0 auto !important;
            }
            .meet-doctor-title {
              font-size: 1.6rem !important;
              text-align: center !important;
              margin-bottom: 14px !important;
            }
            .meet-doctor-subtitle {
              font-size: 0.88rem !important;
              text-align: center !important;
              line-height: 1.6 !important;
              margin-bottom: 14px !important;
            }
            .meet-doctor-content-column {
              width: 100% !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }
            .meet-doctor-qualification-text {
              font-size: 0.85rem !important;
              text-align: center !important;
            }
            .meet-doctor-primary-button {
              padding: 10px 22px !important;
              font-size: 0.9rem !important;
              width: 100% !important;
              max-width: 280px !important;
            }
            .meet-doctor-divider {
              margin: 25px 0 !important;
            }
          }
          
          /* Foldable Devices (Galaxy Z Fold 5, Asus Zenbook Fold) */
          @media (max-width: 768px) and (min-height: 600px) and (max-height: 800px) {
            .meet-doctor-container {
              flex-direction: column !important;
              gap: 35px !important;
              align-items: center !important;
            }
            .meet-doctor-image-column {
              width: 100% !important;
              display: flex !important;
              justify-content: center !important;
            }
            .meet-doctor-image-container {
              width: 260px !important;
              height: 400px !important;
            }
            .meet-doctor-title {
              font-size: 2rem !important;
              text-align: center !important;
            }
            .meet-doctor-subtitle {
              font-size: 1rem !important;
              text-align: center !important;
            }
          }
          
          /* Landscape Mode for Mobile */
          @media (max-width: 896px) and (orientation: landscape) {
            .meet-doctor-container {
              flex-direction: row !important;
              gap: 30px !important;
              align-items: flex-start !important;
            }
            .meet-doctor-image-container {
              width: 180px !important;
              height: 280px !important;
              min-width: 180px !important;
            }
            .meet-doctor-title {
              font-size: 1.5rem !important;
              margin-bottom: 15px !important;
            }
            .meet-doctor-subtitle {
              font-size: 0.85rem !important;
              line-height: 1.5 !important;
              margin-bottom: 15px !important;
            }
            .meet-doctor-primary-button {
              padding: 10px 20px !important;
              font-size: 0.85rem !important;
            }
          }
          
          /* Touch-friendly button sizes */
          .meet-doctor-primary-button {
            min-height: 44px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
        `}
      </style>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 24px',
    backgroundColor: '#ffffff',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '80px',
  },
  imageColumn: {
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
  },
  imageContainer: {
    width: '260px',
    height: '400px',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  contentColumn: {
    flex: '1',
    paddingTop: '20px',
  },
  title: {
    fontSize: '2.8rem',
    fontWeight: '700',
    color: '#1a202c',
    marginBottom: '25px',
    lineHeight: '1.1',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#4a5568',
    lineHeight: '1.7',
    marginBottom: '35px',
    maxWidth: '90%',
  },
  qualifications: {
    marginBottom: '45px',
  },
  qualificationItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '18px',
    fontSize: '1.1rem',
    color: '#2d3748',
    lineHeight: '1.6',
  },
  bullet: {
    color: '#4fd1c5',
    fontWeight: 'bold',
    marginRight: '15px',
    fontSize: '1.2rem',
    minWidth: '20px',
    marginTop: '2px',
  },
  qualificationText: {
    flex: '1',
  },
  buttonContainer: {
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    marginTop: '40px',
  },
  primaryButton: {
    backgroundColor: '#00ba76',
    color: '#ffffff',
    fontWeight: '600',
    padding: '16px 40px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.1rem',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'inline-block',
    textAlign: 'center',
  },
  primaryButtonHover: {
    backgroundColor: '#00a869',
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 20px rgba(0, 186, 118, 0.3)',
  },
  divider: {
    height: '1px',
    backgroundColor: '#e2e8f0',
    margin: '40px 0',
    width: '100%',
  },
};

export default MeetTheDoctor;
